<template>
  <common-dialog ref="dialog" width="700px" title="设置" id-key="id" :data="data" @opened="onOpened"
    :before-save="onBeforeSave" :save-func="saveDataFunc" show-save-button @close-saved="$emit('close-saved')"
    close-on-saved>
    <template slot="form">
      <el-divider>基础设置</el-divider>
      <div>
        <el-form-item label="跨店铺合单" label-width="100px">
          <el-switch v-model="data.spanMerge" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="合单数量限制" label-width="100px">
          <el-switch v-model="data.quantityLimit" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          <div v-if="data.quantityLimit" style="display: inline-block;margin-left: 16px;">
            <el-input v-model="data.quantity" placeholder="请输入数量" />
          </div>
        </el-form-item>
      </div>
      <el-divider>打印设置</el-divider>
      <div>
        <el-form-item label="合并打印" label-width="100px">
          <el-switch v-model="data.mergePrint" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
        <el-form-item label="打印脱敏" label-width="100px">
          <el-radio v-model="data.desensitize" :label="true">脱敏</el-radio>
          <el-radio v-model="data.desensitize" :label="false">不脱敏</el-radio>
          <div class="tip">打印发件人手机号脱敏展示，例如：13******33</div>
        </el-form-item>
        <el-form-item label="打印顺序" label-width="100px">
          <el-radio v-model="data.printSequence" :label="0">按列表顺序</el-radio>
          <el-radio v-model="data.printSequence" :label="1">按规格顺序</el-radio>
        </el-form-item>
      </div>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require('@/api/wx/malladdresses').default,
      data: {
        id: 0,
        spanMerge: false, //跨店铺
        quantityLimit: false, //数量限制
        quantity: null, //数量
        mergePrint: false, //合并打印
        desensitize: false, //数据脱敏
        printSequence: 0, //0：按列表顺序，1：按规格顺序
      },
    };
  },
  mounted() { },
  methods: {
    onOpened() {

    },
    onBeforeSave() {
      console.log("data", this.data);
      return false;
    },
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
        // this.api.postSender(this.data).then(res => {
        //   if (res) {
        //     resolve({ Code: 1, Msg: res.errorMessage })
        //   } else {
        //     resolve({ Code: 0, Msg: null })
        //   }
        // })
      })
    },
  },
};
</script>